// src/components/TaskForm.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { analyzeTasks } from '../features/tasks/taskSlice';

const TaskForm = () => {
    const [tasks, setTasks] = useState([
        {
            id: '1',
            title: '',
            description: '',
            assignee: '',
            due_date: ''
        }
    ]);

    const dispatch = useDispatch();
    const { isLoading, error } = useSelector((state) => state.tasks);

    const handleAddTask = () => {
        setTasks([
            ...tasks,
            {
                id: String(tasks.length + 1),
                title: '',
                description: '',
                assignee: '',
                due_date: '',
            },
        ]);
    };

    const handleTaskChange = (index, field, value) => {
        const updatedTasks = [...tasks];
        updatedTasks[index] = {
            ...updatedTasks[index],
            [field]: value,
        };
        setTasks(updatedTasks);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(analyzeTasks(tasks));
    };

    return (
        <div className="task-form">
            <h2>Enter Tasks Manually</h2>
            <form onSubmit={handleSubmit}>
                {tasks.map((task, index) => (
                    <div key={task.id} className="task-input">
                        <h3>Task {index + 1}</h3>
                        <div className="form-group">
                            <label htmlFor={`title-${index}`}>Title:</label>
                            <input
                                type="text"
                                id={`title-${index}`}
                                value={task.title}
                                onChange={(e) => handleTaskChange(index, 'title', e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor={`description-${index}`}>Description:</label>
                            <textarea
                                id={`description-${index}`}
                                value={task.description}
                                onChange={(e) => handleTaskChange(index, 'description', e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor={`assignee-${index}`}>Assignee:</label>
                            <input
                                type="text"
                                id={`assignee-${index}`}
                                value={task.assignee}
                                onChange={(e) => handleTaskChange(index, 'assignee', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor={`due-date-${index}`}>Due Date:</label>
                            <input
                                type="date"
                                id={`due-date-${index}`}
                                value={task.due_date}
                                onChange={(e) => handleTaskChange(index, 'due_date', e.target.value)}
                            />
                        </div>
                    </div>
                ))}
                <div className="form-actions">
                    <button type="button" onClick={handleAddTask}>
                        Add Another Task
                    </button>
                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Analyzing...' : 'Analyze Tasks'}
                    </button>
                </div>
                {error && <div className="error">{error.message}</div>}
            </form>
        </div>
    );
};

export default TaskForm;